
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Mumbaitoakkalkotcabfare() {



    const cardData =
    {
        keyword: 'Mumbai to Akkalkot Cab Service',
        heading: 'Vedant Travels: Mumbai to Akkalkot Cab Service',
        headingDescription: 'Vedant Travels provides a reliable and comfortable cab service from Mumbai to Akkalkot, ensuring a smooth and hassle-free journey for devotees and travelers. Whether you are visiting the revered Shree Swami Samarth Temple or exploring other sacred sites, our fleet of well-maintained sedans, SUVs, and luxury cars caters to all your travel needs. Our professional drivers prioritize safety and comfort, offering flexible pickup and drop-off options. With 24/7 availability, competitive fares, and an easy online booking system, Vedant Travels makes your Mumbai to Akkalkot trip seamless and convenient.',

        top: 'Top Places to Visit in Akkalkot with Vedant Travels',

"topPlaces": [
    {
        "title": "Shri Swami Samarth Temple",
        "description": "The Shri Swami Samarth Temple is the most famous pilgrimage site in Akkalkot, dedicated to the 19th-century saint Shree Swami Samarth Maharaj, believed to be an incarnation of Lord Dattatreya. Devotees visit the temple to seek his blessings, witness the Maha Prasad, and experience the spiritual atmosphere. The Nirgun Paduka is a sacred object of worship, attracting thousands of devotees daily."
    },
    {
        "title": "Vatavruksha Temple",
        "description": "Located near the Swami Samarth Temple, the Vatavruksha Temple is where Swami Samarth is believed to have meditated under a sacred banyan tree. This site is considered highly spiritual, and devotees gather here to chant prayers and meditate. The banyan tree is believed to hold divine energy, offering peace and solace to visitors."
    },
    {
        "title": "Akhila Bharatiya Sri Swami Samarth Gurupeeth",
        "description": "The Sri Swami Samarth Gurupeeth serves as a spiritual learning center where devotees can participate in religious teachings, meditation sessions, and rituals. The Gurupeeth conducts spiritual discourses, charity programs, and mass prayers, making it an important place for followers of Swami Samarth."
    },
    {
        "title": "Akkalkot Palace (Rajwada)",
        "description": "The Akkalkot Palace, also known as Rajwada, is a historical site showcasing the grandeur of the erstwhile royal family. The palace features stunning architecture, old artifacts, and exhibits that provide insight into Akkalkot's royal heritage. It is an excellent place for history enthusiasts."
    },
    {
        "title": "Mallikarjun Temple",
        "description": "The Mallikarjun Temple is an ancient temple dedicated to Lord Shiva. The temple’s serene surroundings and traditional architecture make it a peaceful spot for worship and meditation. Devotees visit the temple to seek blessings and participate in the Shivratri celebrations held here annually."
    },
    {
        "title": "Gandhi Maidan",
        "description": "For those looking for a quiet retreat, Gandhi Maidan is a great place to relax. This open ground is used for cultural events, spiritual gatherings, and fairs. It offers a peaceful environment for visitors who want to take a break from temple visits."
    },
    {
        "title": "Chandrakala Park",
        "description": "A perfect spot for families, Chandrakala Park in Akkalkot offers green spaces, walking tracks, and recreational areas. The park is a great place to unwind, especially for travelers visiting with children."
    }
],

"services": [
    {
        "name": "Mumbai to Akkalkot Cab Fare",
        "description": "Looking for an affordable and reliable ride to Akkalkot from Mumbai? Vedant Travels offers competitive and transparent pricing for your Mumbai to Akkalkot journey. We ensure no hidden charges, with fair pricing for a comfortable and timely trip."
    },
    {
        "name": "Akkalkot Taxi",
        "description": "Choose Vedant Travels for your Akkalkot taxi needs. We provide professional drivers and well-maintained vehicles to make your journey from Mumbai to Akkalkot comfortable and hassle-free. Book your taxi today for a smooth ride."
    },
    {
        "name": "Mumbai to Akkalkot Cab Service",
        "description": "Travel from Mumbai to Akkalkot with Vedant Travels for a reliable and comfortable journey. Whether you're visiting for business or pilgrimage, our fleet of vehicles ensures a smooth and safe trip to Akkalkot, with flexible booking options."
    },
    {
        "name": "Akkalkot Darshan Cab",
        "description": "Embark on a spiritual journey to Akkalkot with Vedant Travels. Our Akkalkot darshan cab service ensures you can focus on your pilgrimage while we take care of the transportation. Enjoy a safe, comfortable ride with experienced drivers who know the best routes."
    },
    {
        "name": "Mumbai to Akkalkot One Way Taxi",
        "description": "If you're looking for a one-way taxi from Mumbai to Akkalkot, Vedant Travels offers convenient and affordable one-way taxi services. Book your ride with us for a comfortable, stress-free journey to Akkalkot."
    },
    {
        "name": "Akkalkot Car Rental from Mumbai",
        "description": "Rent a car for your trip to Akkalkot with Vedant Travels. Our car rental services offer flexibility, comfort, and reliability, ensuring that you enjoy a smooth ride from Mumbai to Akkalkot. Choose from a variety of vehicles to suit your needs."
    },
    {
        "name": "Mumbai to Akkalkot Innova Crysta",
        "description": "For a premium travel experience, book the Innova Crysta for your Mumbai to Akkalkot journey. The Innova Crysta offers luxurious seating, extra space, and comfort, making it ideal for families or groups traveling to Akkalkot."
    },
    {
        "name": "Mumbai to Akkalkot Taxi Charges",
        "description": "At Vedant Travels, we offer competitive taxi charges for your Mumbai to Akkalkot trip. We ensure affordable pricing with no hidden costs, so you can plan your trip with complete peace of mind. Contact us for a personalized quote based on your specific needs."
    },
    {
        "name": "Mumbai to Akkalkot Travel Services",
        "description": "Vedant Travels offers comprehensive travel services from Mumbai to Akkalkot, including reliable taxi services, car rentals, and one-way or round-trip options. Our experienced drivers and well-maintained vehicles ensure a comfortable and timely journey."
    }
],

"tableData": [
    ["Mumbai to Akkalkot Cab Fare", "Mumbai to Akkalkot Travel Services"],
    ["Mumbai to Akkalkot Cab Service", "Akkalkot Darshan Cab"],
    ["Mumbai to Akkalkot One Way Taxi", "Akkalkot Car Rental from Mumbai"],
    ["Mumbai to Akkalkot Innova Crysta", "Mumbai to Akkalkot Taxi Charges"],
    ["", ""]
  ],
  "whychoose": [
    {
      "WhyChooseheading": "Reliable and On-Time Service",
      "WhyChoosedescription": "At Vedant Travels, we understand how important punctuality is for your trip. Our drivers ensure timely pickups and drop-offs, allowing you to travel between Mumbai and Akkalkot without any stress."
    },
    {
      "WhyChooseheading": "Comfortable and Spacious Vehicles",
      "WhyChoosedescription": "We offer comfortable and spacious vehicles for your journey to Akkalkot. Our well-maintained cars are equipped with ample legroom, air conditioning, and comfortable seating to ensure a relaxing trip."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our drivers are highly skilled and experienced, familiar with the best routes to Akkalkot. They ensure that your ride is smooth, safe, and comfortable throughout the journey."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "At Vedant Travels, we provide competitive and transparent pricing for your Mumbai to Akkalkot journey. There are no hidden fees—just clear and upfront pricing, giving you the best value for your money."
    },
    {
      "WhyChooseheading": "Safe and Comfortable Journey",
      "WhyChoosedescription": "Safety is our top priority. Our vehicles are regularly serviced and equipped with modern safety features such as airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols to ensure you have a secure journey."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "Whether you’re planning an early morning departure or a late-night return, Vedant Travels is available around the clock. Our customer service team is ready to assist you at any time of the day or night."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking Process",
      "WhyChoosedescription": "Booking your Mumbai to Akkalkot cab is quick and easy. You can book online through our website or app, or simply contact our customer service team for assistance with the reservation."
    },
    {
      "WhyChooseheading": "Customized Travel Packages",
      "WhyChoosedescription": "We offer personalized travel packages to suit your needs, whether you're traveling for religious purposes or a leisurely trip. Let us know your preferences, and we’ll ensure your journey is tailored to your comfort."
    }
  ]


    }
    const faqData = [
        {
            id: 1,
            question: 'How can I book a Mumbai to Akkalkot cab with Vedant Travels?',
            answer: 'You can easily book your cab online via our website or mobile app. Alternatively, our customer service team is available to help you with your booking over the phone.',
        },
        {
            id: 2,
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, our drivers are highly trained and experienced in long-distance travel, including the route from Mumbai to Akkalkot. They ensure a safe and comfortable ride.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for Mumbai to Akkalkot travel?',
            answer: 'We offer a range of well-maintained vehicles, including sedans, SUVs, and luxury cars. All our vehicles are spacious and designed for comfort during long journeys.',
        },
        {
            id: 4,
            question: 'How do I pay for my Mumbai to Akkalkot cab rental?',
            answer: 'We accept multiple payment methods, including cash, credit/debit cards, and online payment via our app for your convenience.',
        },
        {
            id: 5,
            question: 'Can I book a round trip from Mumbai to Akkalkot?',
            answer: 'Yes, we offer round-trip services. Simply provide your return details when booking, and we will ensure a smooth trip back to Mumbai.',
        },
        {
            id: 6,
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any additional charges for waiting or detours will be communicated clearly to you upfront. We believe in complete transparency, ensuring no hidden charges.',
        },
        {
            id: 7,
            question: 'Can I hire a cab for sightseeing in Akkalkot?',
            answer: 'Yes, we offer sightseeing services for Akkalkot. Visit important landmarks like the Akkalkot Swami Samarth Temple and other local attractions with the guidance of a trusted driver.',
        },
        {
            id: 8,
            question: 'What is the luggage allowance for a Mumbai to Akkalkot cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have additional luggage or special requirements, please let us know at the time of booking, and we’ll make the necessary arrangements.',
        },
        {
            id: 9,
            question: 'Is Vedant Travels available for corporate travel to Akkalkot?',
            answer: 'Yes, we offer corporate travel services for meetings, conferences, and business trips. We provide tailored solutions to meet your professional needs on the Mumbai to Akkalkot route.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for Mumbai to Akkalkot travel?',
            answer: 'Vedant Travels offers reliable, affordable, and comfortable services with professional drivers, well-maintained vehicles, and transparent pricing. We ensure that your trip to Akkalkot is safe, smooth, and enjoyable.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Ashok Sharma",
            title: "Religious Traveler",
            quote: "I traveled from Mumbai to Akkalkot for a religious trip, and I’m very pleased with Vedant Travels. The vehicle was very comfortable, the driver was punctual and professional, and I reached my destination on time. Highly recommend!",
            rating: 5,
        },
        {
            name: "Mrs. Meena Joshi",
            title: "Family Traveler",
            quote: "Our family had a wonderful experience traveling from Mumbai to Akkalkot with Vedant Travels. The car was spacious, and the driver was very courteous. The whole trip was smooth and enjoyable. We'll definitely use their service again!",
            rating: 5,
        },
    ];
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    
   
  
  const jsonData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Mumbai to Akkalkot Cab Fare | Vedant Travels",
    "description": "Book your Mumbai to Akkalkot cab with Vedant Travels for a hassle-free and comfortable journey. We offer affordable taxi services for one-way trips, Akkalkot darshan, and car rentals. Choose from premium vehicles like Innova Crysta, Ertiga, and Swift Dzire.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.8",
      "ratingCount": "800"
    }
  };
  
   
      


    return (
        <div>
            <Helmet>
    <title>Mumbai to Akkalkot Cab Fare | Vedant Travels | Contact: +91 8767459909</title>
    <meta name="description" content="Book your Mumbai to Akkalkot cab with Vedant Travels. We provide affordable and reliable taxi services for one-way trips, Akkalkot darshan, and car rentals. Choose from premium vehicles like Innova Crysta, Ertiga, and Swift Dzire." />
    <meta name="keywords" content="mumbai to akkalkot cab fare, akkalkot taxi, mumbai to akkalkot cab service, akkalkot darshan cab, mumbai to akkalkot one way taxi, akkalkot car rental from mumbai, mumbai to akkalkot innova crysta, mumbai to akkalkot taxi charges, mumbai to akkalkot travel services" />
    <meta name="robots" content="index, follow" />
    <link rel="canonical" href="https://www.vedanttravels.in/mumbai-to-akkalkot-cab-fare" />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>
           
            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/79.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitoakkalkotcabfare;